import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Modals/CashbackModal/cashbackModal"
    ).then((module) => ({
        default: module.CashbackModal
    }))
);
